import styled from 'styled-components';
import { layout } from 'src/components/base';
import { IconArrowLeft } from '@prisjakt/ui/icon/arrow-left';
import { IconArrowRight } from '@prisjakt/ui/icon/arrow-right';
import { Tooltip as TooltipComponent } from 'src/components/tooltip-new';
import { Button } from 'src/components/button';

const ARROW_ICON_MARGIN = '-3px';

const Tooltip = styled(TooltipComponent)``;

const FilterToggleButton = styled.button<{ active?: boolean }>`
  display: flex;
  align-items: center;
  align-self: stretch;
  outline: none;
  cursor: pointer;
  padding: 0 8px;
  min-height: 43px;
  position: relative;
  fill: ${props =>
    props.active ? props.theme.colors.base700 : props.theme.colors.base400};
  background-color: ${props =>
    props.active ? props.theme.colors.yellove500 : 'transparent'};
  svg {
    margin-top: -1px;
  }

  :hover {
    svg g,
    svg path {
      fill: ${props =>
        props.active
          ? props.theme.colors.base700
          : props.theme.colors.positive500};
    }
  }
`;

const ArrowIconLeft = styled(IconArrowLeft)`
  margin-left: ${ARROW_ICON_MARGIN};
`;

const ArrowIconRight = styled(IconArrowRight)`
  margin-left: ${ARROW_ICON_MARGIN};
`;

const SidebarFilterButton = styled(Button)`
  margin-left: ${layout.measurements.spacing050};
`;

export {
  Tooltip,
  FilterToggleButton,
  ArrowIconLeft,
  ArrowIconRight,
  SidebarFilterButton,
};
